
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";
import { FolderUser } from "@/models/tasks/folder-user";
import { TaskService } from "@/services/task-service";

export default Vue.extend({
	data(){
		return {
			folderUsers: [] as FolderUser[]
		};
	},
	props: {
		value: {
			type: [String, Array as ()=>string[]],
			required: true
		},
		multi: Boolean,
		label: {
			type: [Object as ()=>TranslateResult, String],
			default():TranslateResult{
				return this.$ct("folder");
			}
		}
	},
	computed: {
		folders(): ISelectItem<number>[] {
			return this.folderUsers.map((f)=>{
				return {
					value: f.FolderID,
					text: f.Folder?.Name || ""
				};
			});
		},
		singleItemValue():number {
			if (typeof(this.value) == "string") {
				return this.parseNum(this.value);
			}
			return this.parseNum(this.value[0]);
		},
		multiItemValue():number[] {
			if (typeof(this.value) == "string") {
				return [this.parseNum(this.value)];
			}
			return this.value.map(v=>this.parseNum(v));
		}
	},
	methods: {
		parseNum(num:string):number{
			let result = parseInt(num || "0");
			if (Number.isNaN(result)) return 0;
			return result;
		},
		setSingleItemValue(val:number){
			this.$emit("input", `${val}`);
		},
		setMultiItemValue(val:number[]){
			this.$emit("input", val.map(v=>`${v}`));
		}
	},
	async created(){
		this.folderUsers = await TaskService.getFolders();
	},
	i18nEx: {
		componentPrefix: "components.models"
	}
});
